<template>
  <div>
    <div
      class="fhs-pre-logout-screen"
      v-if="is_loggined"
      :class="{ toggle: pre_logout }"
    >
      <div class="progress-rail">
        <div
          class="progress-line"
          :style="{ width: `${(timer_counter * 100) / 61}%` }"
        ></div>
      </div>
      <div class="logout-modal" :class="{ close: !pre_logout }">
        <h3 style="">
          Вам требуется дополнительное время?
        </h3>
        <h4 style="margin-bottom: 10px;font-weight: normal">
          До окончания вашей сессии осталось: {{ 60 - timer_counter }} секунд
        </h4>
        <button class="btn white" @click="continueSession">
          Продолжить
        </button>
      </div>
    </div>
    <div class="fhs-auth-lock-screen" v-show="status_msg.length > 0">
      <div class="row center-xs middle-xs" style="height: 100%">
        <div class="col-xs-9 col-sm-4">
          <div>
            <h3>{{ $t(status_msg) }}</h3>
            <br />
            <button class="button filled form__button" @click="close">
              Войти
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import mn from "moment";
export default {
  data() {
    return {
      end: this.token_data,
      pre_logout: false,
      pre_logout_progressbar: 0,
      timer_counter: 0,
      timer: null,
      timer_text: null
    };
  },
  computed: {
    ...mapGetters({
      status_msg: "Request_MODULE/_status_code/getStatusCode",
      token_data: "token_data",
      is_loggined: "isLoggedIn"
    })
  },
  watch: {
    token_data: function(value) {
      this.mainTimer(value);
    }
  },
  methods: {
    mainTimer(value) {
      clearInterval(this.$store.state.session_timer);
      if (value !== null) {
        this.$store.state.session_timer = setInterval(() => {
          if (this.is_loggined) {
            this.refresh();
          } else {
            clearInterval(this.$store.state.session_timer);
          }
        }, value.loop_time); // access - issue (20 sec example)
      }
    },
    refresh() {
      this.$store.dispatch("userLoginRefresh").then(res => {
        if (res.data.code === 401) {
          this.logout();
        }
      });
    },
    continueSession() {
      clearInterval(this.timer);
      this.$toasted.success("Ваша сессия продлена");
      this.pre_logout = false;
    },
    close() {
      this.$router.push({ name: "auth-login" });
      this.$store.commit("Request_MODULE/_status_code/setStatusCode", "");
    },
    logout() {
      this.$store.commit(
        "Request_MODULE/_status_code/setStatusCode",
        "Active token not found"
      );
      this.$store.dispatch("userLogout").finally(() => {});
    }
  },
  onIdle() {
    if (!this.pre_logout && this.is_loggined) {
      clearInterval(this.timer);
      this.pre_logout = true;
      this.timer_counter = 0;
      this.timer = setInterval(() => {
        if (!this.is_loggined) {
          clearInterval(this.timer);
        }
        this.timer_counter++;
        if (this.timer_counter === 61) {
          this.timer_counter = 0;
          this.pre_logout = false;
          clearInterval(this.timer);
          this.logout();
        }
      }, 1000);
    }
  },
  onActive() {},
  beforeMount() {
    this.mainTimer(this.token_data);
  }
};
</script>

<style scoped>
.fhs-pre-logout-screen {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 80;
  opacity: 0;
  pointer-events: none;
  transition: 0.1s;
}
.fhs-pre-logout-screen.toggle {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.4);
  pointer-events: auto;
}
.fhs-pre-logout-screen .progress-rail {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.fhs-pre-logout-screen .progress-line {
  width: 0%;
  height: 5px;
  z-index: 90;
  background-color: #1a75e9;
  transition: 1s width;
}
.fhs-pre-logout-screen .logout-modal {
  text-align: left;
  position: absolute;
  color: white;
  padding: 15px;
  border-radius: 5px;
  background-color: #1a75e9;
  box-shadow: 0px 4px 10px rgba(29, 131, 255, 0.3);
  top: 20px;
  right: 0px;
  transform: translateX(-20px);
  transition: 0.5s;
}
.fhs-pre-logout-screen .logout-modal.close {
  transform: translateX(+110%);
}
.btn {
  border-radius: 4px;
  border: none;
  padding: 7px 10px;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.15);
}
.btn:disabled {
  opacity: 0.7;
}
.btn.white {
  background-color: white;
  color: #1a75e9;
}
/*-------------------------------------------------------*/
.fhs-auth-lock-screen {
  color: white !important;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
